import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import Vue from 'vue';
import config from './config';

export default () => {
  if ( config.ravenJs ) {
    Raven
      .config(config.ravenJs, {
        environment: process.env.NODE_ENV
      })
      .addPlugin(RavenVue, Vue)
      .install();
  }
};


// WEBPACK FOOTER //
// ./src/config/raven.config.js